/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StageWithGroups } from './StageWithGroups';
import {
    StageWithGroupsFromJSON,
    StageWithGroupsFromJSONTyped,
    StageWithGroupsToJSON,
    StageWithGroupsToJSONTyped,
} from './StageWithGroups';

/**
 * 
 * @export
 * @interface CategoryWithStructure
 */
export interface CategoryWithStructure {
    /**
     * 
     * @type {string}
     * @memberof CategoryWithStructure
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryWithStructure
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryWithStructure
     */
    gender?: string;
    /**
     * 
     * @type {Array<StageWithGroups>}
     * @memberof CategoryWithStructure
     */
    stages?: Array<StageWithGroups>;
}

/**
 * Check if a given object implements the CategoryWithStructure interface.
 */
export function instanceOfCategoryWithStructure(value: object): value is CategoryWithStructure {
    return true;
}

export function CategoryWithStructureFromJSON(json: any): CategoryWithStructure {
    return CategoryWithStructureFromJSONTyped(json, false);
}

export function CategoryWithStructureFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoryWithStructure {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'gender': json['gender'] == null ? undefined : json['gender'],
        'stages': json['stages'] == null ? undefined : ((json['stages'] as Array<any>).map(StageWithGroupsFromJSON)),
    };
}

export function CategoryWithStructureToJSON(json: any): CategoryWithStructure {
    return CategoryWithStructureToJSONTyped(json, false);
}

export function CategoryWithStructureToJSONTyped(value?: CategoryWithStructure | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'gender': value['gender'],
        'stages': value['stages'] == null ? undefined : ((value['stages'] as Array<any>).map(StageWithGroupsToJSON)),
    };
}

